import React from 'react';
import type { PressableProps, TextStyle, View, ViewStyle } from 'react-native';
import { Animated, Easing, Pressable } from 'react-native';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

interface Props extends Omit<PressableProps, 'disabled'> {
  text: string;
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
  style?: any;
}

const spinnerXml = `
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 9.58273C11.8525 9.58273 11.7248 9.53058 11.6169 9.42626C11.5126 9.31835 11.4604 9.19065 11.4604 9.04317V6.53957C11.4604 6.39568 11.5126 6.26978 11.6169 6.16187C11.7248 6.05396 11.8525 6 12 6C12.1475 6 12.2734 6.05396 12.3777 6.16187C12.4856 6.26978 12.5396 6.39568 12.5396 6.53957V9.04317C12.5396 9.19065 12.4856 9.31835 12.3777 9.42626C12.2734 9.53058 12.1475 9.58273 12 9.58273ZM13.705 10.295C13.6007 10.1871 13.5486 10.0576 13.5486 9.90647C13.5486 9.7554 13.6007 9.6277 13.705 9.52338L15.4748 7.75899C15.5791 7.65468 15.7068 7.60252 15.8579 7.60252C16.009 7.60252 16.1367 7.65468 16.241 7.75899C16.3453 7.86331 16.3975 7.99101 16.3975 8.14209C16.3975 8.29317 16.3453 8.42086 16.241 8.52518L14.4766 10.295C14.3759 10.3993 14.2482 10.4532 14.0935 10.4568C13.9424 10.4568 13.8129 10.4029 13.705 10.295ZM14.4119 12C14.4119 11.8489 14.4658 11.7212 14.5737 11.6169C14.6853 11.5126 14.8147 11.4604 14.9622 11.4604H17.4604C17.6043 11.4604 17.7302 11.5126 17.8381 11.6169C17.946 11.7212 18 11.8489 18 12C18 12.1511 17.946 12.2788 17.8381 12.3831C17.7338 12.4874 17.6079 12.5396 17.4604 12.5396H14.9622C14.8147 12.5396 14.6853 12.4874 14.5737 12.3831C14.4658 12.2788 14.4119 12.1511 14.4119 12ZM13.705 13.705C13.8129 13.6007 13.9424 13.5486 14.0935 13.5486C14.2446 13.5486 14.3723 13.6007 14.4766 13.705L16.241 15.4748C16.3453 15.5791 16.3975 15.7068 16.3975 15.8579C16.3975 16.009 16.3453 16.1367 16.241 16.241C16.1367 16.3453 16.009 16.3975 15.8579 16.3975C15.7068 16.3975 15.5791 16.3453 15.4748 16.241L13.705 14.4766C13.6007 14.3723 13.5486 14.2446 13.5486 14.0935C13.5486 13.9424 13.6007 13.8129 13.705 13.705ZM12 14.4173C12.1475 14.4173 12.2734 14.4712 12.3777 14.5791C12.4856 14.687 12.5396 14.8129 12.5396 14.9568V17.4604C12.5396 17.6043 12.4856 17.7302 12.3777 17.8381C12.2734 17.946 12.1475 18 12 18C11.8525 18 11.7248 17.946 11.6169 17.8381C11.5126 17.7302 11.4604 17.6043 11.4604 17.4604V14.9568C11.4604 14.8129 11.5126 14.687 11.6169 14.5791C11.7248 14.4712 11.8525 14.4173 12 14.4173ZM10.295 13.705C10.4029 13.8129 10.455 13.9424 10.4514 14.0935C10.4514 14.2446 10.3993 14.3723 10.295 14.4766L8.52518 16.241C8.42086 16.3453 8.29317 16.3975 8.14209 16.3975C7.99101 16.3975 7.86331 16.3453 7.75899 16.241C7.65468 16.1367 7.60252 16.009 7.60252 15.8579C7.60252 15.7068 7.65468 15.5791 7.75899 15.4748L9.52338 13.705C9.6277 13.6007 9.7554 13.5486 9.90647 13.5486C10.0576 13.5486 10.1871 13.6007 10.295 13.705ZM9.58813 12C9.58813 12.1511 9.53237 12.2788 9.42086 12.3831C9.31295 12.4874 9.18705 12.5396 9.04317 12.5396H6.53957C6.39568 12.5396 6.26978 12.4874 6.16187 12.3831C6.05396 12.2788 6 12.1511 6 12C6 11.8489 6.05396 11.7212 6.16187 11.6169C6.26978 11.5126 6.39568 11.4604 6.53957 11.4604H9.04317C9.18705 11.4604 9.31295 11.5126 9.42086 11.6169C9.53237 11.7212 9.58813 11.8489 9.58813 12ZM10.295 10.295C10.1871 10.4029 10.0576 10.4568 9.90647 10.4568C9.7554 10.4532 9.6277 10.3993 9.52338 10.295L7.75899 8.52518C7.65468 8.42086 7.60252 8.29317 7.60252 8.14209C7.60252 7.99101 7.65468 7.86331 7.75899 7.75899C7.86331 7.65468 7.99101 7.60252 8.14209 7.60252C8.29317 7.60252 8.42086 7.65468 8.52518 7.75899L10.295 9.52338C10.3993 9.6277 10.4514 9.7554 10.4514 9.90647C10.4514 10.0576 10.3993 10.1871 10.295 10.295Z"/>
  </svg>
`;

const LoadingSpinner = ({ fill }: SvgProps) => {
  const { styles } = useStyles(stylesheet);
  const rotation = React.useRef(new Animated.Value(0)).current;

  React.useEffect(() => {
    const animation = Animated.loop(
      Animated.timing(rotation, {
        toValue: 1,
        duration: 900,
        easing: Easing.linear,
        useNativeDriver: true,
      })
    );

    animation.start();

    return () => animation.stop();
  }, [rotation]);

  return (
    <Animated.View
      style={[
        styles.spinner,
        {
          transform: [
            {
              rotate: rotation.interpolate({
                inputRange: [0, 1],
                outputRange: ['0deg', '360deg'],
              }),
            },
          ],
        },
      ]}
    >
      <SvgXml xml={spinnerXml} width="100%" height="100%" fill={fill} />
    </Animated.View>
  );
};

export const EonOneButton = React.forwardRef<View, Props>(
  (
    { text, loading = false, disabled = false, onPress, style, ...props },
    ref
  ) => {
    const { styles, theme } = useStyles(stylesheet);
    const [pressed, setPressed] = React.useState(false);
    const [hover, setHover] = React.useState(false);

    const showDisabled = disabled || loading;

    let stateStyle: ViewStyle = styles.default;
    let textStyle: TextStyle = styles.textDefault;

    switch (true) {
      case showDisabled:
        stateStyle = styles.disabled;
        textStyle = styles.textDisabled;
        break;
      case pressed:
        stateStyle = styles.pressed;
        textStyle = styles.textPressed;
        break;
      case hover:
        stateStyle = styles.hover;
        textStyle = styles.textHover;
        break;
    }

    return (
      <Pressable
        disabled={showDisabled}
        {...props}
        ref={ref}
        hitSlop={8}
        onPressIn={() => setPressed(true)}
        onPressOut={() => setPressed(false)}
        onPress={onPress}
        onHoverIn={() => setHover(true)}
        onHoverOut={() => setHover(false)}
        style={[
          styles.button,
          stateStyle,
          style,
          !showDisabled && pressed ? styles.pressedOpacity : null,
        ]}
      >
        {loading ? (
          <LoadingSpinner fill={theme.colors.button.primary.default.text} />
        ) : null}
        <Text style={[styles.text, textStyle]}>{text}</Text>
      </Pressable>
    );
  }
);

const stylesheet = createStyleSheet((theme) => ({
  button: {
    height: 50,
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 8,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    alignSelf: 'flex-start',
  },
  spinner: {
    width: 24,
    height: 24,
  },
  text: {
    fontFamily: 'DMSans-Regular',
    fontSize: 17,
    fontWeight: 500,
    lineHeight: 22,
    letterSpacing: -0.43,
  },
  default: {
    backgroundColor: theme.colors.button.primary.default.fill,
  },
  textDefault: {
    color: theme.colors.button.primary.default.text,
  },
  hover: {
    backgroundColor: theme.colors.button.primary.hover.fill,
  },
  textHover: {
    color: theme.colors.button.primary.hover.text,
  },
  pressed: {
    backgroundColor: theme.colors.button.primary.pressed.fill,
  },
  textPressed: {
    color: theme.colors.button.primary.pressed.text,
  },
  pressedOpacity: {
    opacity: 0.5,
  },
  disabled: {
    backgroundColor: theme.colors.button.primary.default.fill,
  },
  textDisabled: {
    color: theme.colors.button.primary.default.text,
  },
}));
